import {SegmentType, UserSegment} from "~src/interfaces/segment.interface";
import {useSelector} from "react-redux";
import {StoreI} from "~src/rootReducer";
import {SessionUserI} from "~src/interfaces/session.types";


export function useSessionUser(): SessionUserI|undefined {
  const user = useSelector((state: StoreI) => state.user.session.user);
  return user || undefined;
}

export function useAuthenticatedUser(): UserSegment|undefined {
  const user = useSessionUser();
  if (!user) {
    return undefined;
  }

  let managerUuid = '';
  Object.keys(user.manager_attributes).forEach((key) => {
      managerUuid = user.manager_attributes[key]?.uuid || '';
  })

  return {
    type: SegmentType.User,
    id: user.uuid,
    image_url: user.imageUrl || '',
    meta: {
      manager_uuid: managerUuid,
      firstname: user.firstname,
      email: user.email,
      lastname: user.lastname,
      name: `${user.firstname} ${user.lastname}`,
    },
  }
}
